export default {
    "en": {
        "All_Educators_Body_Title1": "Todo Math for the Classroom",
        "All_Educators_Body_Title1_Description1": "Engaging, inclusive, standards-aligned math center<br>activity for early learners",
        "All_Educators_Body_Title1_button1": "60 day free trial",
        "All_Educators_Body_Title1_button2": "Request a Quote",
        "All_Educators_Body_Title1_Quote1": "“Best thing I did for my class this year. Wish I had the app sooner. We use it almost daily.”",
        "All_Educators_Body_Title1_Quote2": "“My students are used to struggling but this app allows them to progress at their own speed”",
        "All_Educators_Body_Title1_Quote3": "“I have my students work on Todo Math after our math lesson. I love that they think they are playing a game when in reality they are doing standards correlated with math practice.”",
        "All_Educators_Body_Title2": "What You Get",
        "All_Educators_Body_Title2_Description1": "Todo Math for the Classroom includes Todo Math<br>application as well as features specifically designed<br>for teachers.",
        "All_Educators_Body_Title2_Subtitle1": "Online Teacher Dashboard",
        "All_Educators_Body_Title2_Subtitle1_Description1": "Create class list",
        "All_Educators_Body_Title2_Subtitle1_Description2": "Generate reports",
        "All_Educators_Body_Title2_Subtitle1_Description3": "Track student progress",
        "All_Educators_Body_Title2_Subtitle2": "Todo Math mobile application",
        "All_Educators_Body_Title2_Subtitle2_Description1": "Featuring 700+ fun math activities",
        "All_Educators_Body_Title2_Subtitle2_Description2": "60+ standards-aligned missions",
        "All_Educators_Body_Title3": "Why Todo Math",
        "All_Educators_Body_Title3_Description1": "Teachers and students in over 1,200 classrooms LOVE Todo Math",
        "All_Educators_Body_Title3_Subtitle1": "Common Core Aligned Curriculum",
        "All_Educators_Body_Title3_Subtitle2": "Designed for Early Learners",
        "All_Educators_Body_Title3_Subtitle3": "Multiple Award<br>Winning",
        "All_Educators_Body_Title3_Subtitle4": "Inclusive and<br>Accessible",
        "All_Educators_Body_Title4": "Educator Resources",
        "All_Educators_Body_Title4_Description1": "Get resources for teachers to help parents support<br>their children at home",
        "All_Educators_Body_Title4_Subtitle1": "Back-to-School Night<br>Presentation",
        "All_Educators_Body_Title4_Subtitle2": "Family Letter",
        "All_Educators_Body_Title4_Subtitle3": "Parents Resource Guide",
        "All_Educators_Body_Title4_Subtitle4": "Todo Math Activity Guide",
        "All_Educators_Body_Title4_Button1": "Download (PDF)",
        "All_Educators_Body_Title4_Button2": "Color version (DOCX)",
        "All_Educators_Body_Title4_Button3": "Black and white version (DOCX)",
        "All_Educators_Body_Title1_Quote1_source1": "Lisa,<br>1st Grade Teacher, NJ",
        "All_Educators_Body_Title1_Quote2_source1": "Anonymous,<br>2015 Teacher Perception Survey",
        "All_Educators_Body_Title1_Quote3_source1": "Special Education Teacher",
        "All_Educators_Body_Title5": "Start Todo Math now<br>For your school<br>and classroom",
        "All_Educators_Body_Title1_Subtitle1": "What teachers are saying"
    },
    "ko": {
        "All_Educators_Body_Title1": "토도수학 교실",
        "All_Educators_Body_Title1_Description1": "표준 교과 과정을 준수하고 다양한 학습자들을 배려하여 만든<br>즐거운 수학 활동",
        "All_Educators_Body_Title1_button1": "60일 무료 체험",
        "All_Educators_Body_Title1_button2": "비용 문의",
        "All_Educators_Body_Title1_Quote1": "\"올해 우리 반을 위해서 한 일 중 가장 잘 한<br>일이에요. 좀 더 일찍 알았으면 좋았을 걸!<br>거의 매일 사용하고 있어요.\"",
        "All_Educators_Body_Title1_Quote2": "\"우리 반 아이들은 수학과 씨름하는데만<br>익숙했었는데, 이 앱을 사용하면서부터는<br>각자의 속도에 맞게 공부할 수 있게 됐어요.\"",
        "All_Educators_Body_Title1_Quote3": "\"수학 진도를 나가고 나면 아이들에게<br>토도수학을 시켜요. 실제로는 수학 연습<br>중인데도, 그저 게임인줄 알고 즐기는<br>아이들을 지켜보는게 재밌네요.\"",
        "All_Educators_Body_Title2": "교실버전에는 무엇이 포함되나요?",
        "All_Educators_Body_Title2_Description1": "토도수학 교실은 토도수학 앱 뿐만 아니라 선생님들을 위해<br>특별히 준비한 기능들을 제공합니다.",
        "All_Educators_Body_Title2_Subtitle1": "온라인 선생님 대쉬보드",
        "All_Educators_Body_Title2_Subtitle1_Description1": "교실 목록 만들기",
        "All_Educators_Body_Title2_Subtitle1_Description2": "성적표 만들기",
        "All_Educators_Body_Title2_Subtitle1_Description3": "학생별 진도 확인하기",
        "All_Educators_Body_Title2_Subtitle2": "토도수학 모바일앱",
        "All_Educators_Body_Title2_Subtitle2_Description1": "700가지 이상의 재미있는 수학 활동",
        "All_Educators_Body_Title2_Subtitle2_Description2": "표준 교과를 반영한 60가지 이상의 미션",
        "All_Educators_Body_Title3": "왜 토도수학을 선택할까요?",
        "All_Educators_Body_Title3_Description1": "1,200개 이상의 교실에서 수많은 선생님들과 학생들의<br>사랑을 받고 있습니다.",
        "All_Educators_Body_Title3_Subtitle1": "공통 핵심 교과 과정 준수",
        "All_Educators_Body_Title3_Subtitle2": "기초 학습자를 위한 디자인",
        "All_Educators_Body_Title3_Subtitle3": "다양한 수상 경력",
        "All_Educators_Body_Title3_Subtitle4": "다양한 학습자의 필요를 배려한 기능",
        "All_Educators_Body_Title4": "선생님용 자료",
        "All_Educators_Body_Title4_Description1": "학부모들이 가정에서 아이들을 지도하도록 돕는데 활용할 수<br>있는 자료를 제공합니다.",
        "All_Educators_Body_Title4_Subtitle1": "개학 맞이 학부모 면담 프레젠테이션 자료(미국한정)",
        "All_Educators_Body_Title4_Subtitle2": "가정 통신문",
        "All_Educators_Body_Title4_Subtitle3": "부모용 가이드",
        "All_Educators_Body_Title4_Subtitle4": "토도수학 활동 가이드",
        "All_Educators_Body_Title4_Button1": "다운로드 (PDF)",
        "All_Educators_Body_Title4_Button2": "컬러 버전 (DOCX)",
        "All_Educators_Body_Title4_Button3": "흑백 버전 (DOCX)",
        "All_Educators_Body_Title1_Quote1_source1": "Lisa,<br>초등 1학년 교사, 미국 뉴저지 주",
        "All_Educators_Body_Title1_Quote2_source1": "익명,<br>2015년 교사 대상 인식 조사",
        "All_Educators_Body_Title1_Quote3_source1": "특수 교육 교사",
        "All_Educators_Body_Title5": "토도수학을<br>교실과 학교에서<br>지금 시작해보세요!",
        "All_Educators_Body_Title1_Subtitle1": "교사들의 사용후기"
    },
    "cn": {
        "All_Educators_Body_Title1": "都都数学课堂版",
        "All_Educators_Body_Title1_Description1": "针对早期学习者的参与，包容，标准一致的<br>数学中心活动",
        "All_Educators_Body_Title1_button1": "60天免费试用",
        "All_Educators_Body_Title1_button2": "请求报价",
        "All_Educators_Body_Title1_Quote1": "“今年我为我的班级做的最好的事情。<br>希望我能早点使用该应用程序。<br>我们几乎每天都在使用它。”",
        "All_Educators_Body_Title1_Quote2": "“我的学生习惯于挣扎，但这个应用程序允许<br>他们以自己的速度前进。”",
        "All_Educators_Body_Title1_Quote3": "“在我们的数学课之后，我让我的学生<br>学习都都数学。我喜欢他们认为自己<br>在玩游戏，而实际上他们是在做与数学<br>实践相关的标准。”",
        "All_Educators_Body_Title2": "你得到什么",
        "All_Educators_Body_Title2_Description1": "学校版都都数学包括都都数学应用程序以及<br>专为教师设计的功能。",
        "All_Educators_Body_Title2_Subtitle1": "在线教师管理端",
        "All_Educators_Body_Title2_Subtitle1_Description1": "创建班级列表",
        "All_Educators_Body_Title2_Subtitle1_Description2": "生成报告",
        "All_Educators_Body_Title2_Subtitle1_Description3": "跟踪学生的进度",
        "All_Educators_Body_Title2_Subtitle2": "都都数学移动应用程序",
        "All_Educators_Body_Title2_Subtitle2_Description1": "拥有700多个有趣的数学活动",
        "All_Educators_Body_Title2_Subtitle2_Description2": "60多个符合标准的任务",
        "All_Educators_Body_Title3": "为什么是都都数学",
        "All_Educators_Body_Title3_Description1": "超过1200个教室的教师和学生爱<br>都都数学",
        "All_Educators_Body_Title3_Subtitle1": "共同核心课程",
        "All_Educators_Body_Title3_Subtitle2": "专为早期学习者设计",
        "All_Educators_Body_Title3_Subtitle3": "多次获奖",
        "All_Educators_Body_Title3_Subtitle4": "包容性和无障碍",
        "All_Educators_Body_Title4": "教育者资源",
        "All_Educators_Body_Title4_Description1": "获得教师资源帮助父母在家里<br>支持他们的孩子",
        "All_Educators_Body_Title4_Subtitle1": "回到学校的夜间演讲",
        "All_Educators_Body_Title4_Subtitle2": "家庭信件",
        "All_Educators_Body_Title4_Subtitle3": "家长资源指南",
        "All_Educators_Body_Title4_Subtitle4": "都都数学活动指南",
        "All_Educators_Body_Title4_Button1": "下载（PDF）",
        "All_Educators_Body_Title4_Button2": "彩色版本（DOCX）",
        "All_Educators_Body_Title4_Button3": "黑白版本（DOCX）",
        "All_Educators_Body_Title1_Quote1_source1": "丽莎，一年级老师，新泽西州",
        "All_Educators_Body_Title1_Quote2_source1": "匿名，2015年教师感知调查",
        "All_Educators_Body_Title1_Quote3_source1": "特殊教育教师",
        "All_Educators_Body_Title5": "立即为您的学校<br>和教室开始开启<br>都都数学",
        "All_Educators_Body_Title1_Subtitle1": "老师在说什么"
    },
    "ja": {
        "All_Educators_Body_Title1": "トドさんすうクラス",
        "All_Educators_Body_Title1_Description1": "標準教科過程に従い、多様な学習者に配慮して作られた楽しい算数の活動",
        "All_Educators_Body_Title1_button1": "60日無料体験",
        "All_Educators_Body_Title1_button2": "料金についてのお問い合わせ",
        "All_Educators_Body_Title1_Quote1": "「今年、私のクラスのためにした事の中で一番良かった事です。もっと早く知っていたらよかったのに！ほぼ毎日使っています。」",
        "All_Educators_Body_Title1_Quote2": "「私のクラスの子どもたちは、算数に真剣に取り組むことだけには慣れていたのに、このアプリを使うようになってからは、それぞれの速度に合わせて勉強できるようになりました。」",
        "All_Educators_Body_Title1_Quote3": "「算数の学習が進んできたら、お子さまにトドさんすうをさせてみてください。算数の勉強をしているのに、ゲーム感覚で楽しんでいる子どもたちを見ると嬉しくなりますね」",
        "All_Educators_Body_Title2": "クラスバージョンには何が含まれますか？",
        "All_Educators_Body_Title2_Description1": "トドさんすうクラスは、トドさんすうアプリだけでなく、教師のために特別に準備した機能を提供します。",
        "All_Educators_Body_Title2_Subtitle1": "オンライン教師ダッシュボード",
        "All_Educators_Body_Title2_Subtitle1_Description1": "クラスリスト作成",
        "All_Educators_Body_Title2_Subtitle1_Description2": "成績表作成",
        "All_Educators_Body_Title2_Subtitle1_Description3": "学習者別進度確認",
        "All_Educators_Body_Title2_Subtitle2": "トドさんすうモバイルアプリ",
        "All_Educators_Body_Title2_Subtitle2_Description1": "700種以上の楽しい算数の活動",
        "All_Educators_Body_Title2_Subtitle2_Description2": "標準教科過程を反映した60種類以上のミッション",
        "All_Educators_Body_Title3": "なぜ、トドさんすうが選ばれるのでしょうか？",
        "All_Educators_Body_Title3_Description1": "1,200以上のクラスで、多くの教師と児童に親しまれています。",
        "All_Educators_Body_Title3_Subtitle1": "共通教科過程遵守",
        "All_Educators_Body_Title3_Subtitle2": "基礎学習者のためのデザイン",
        "All_Educators_Body_Title3_Subtitle3": "多数の受賞経歴",
        "All_Educators_Body_Title3_Subtitle4": "多様な学習者のニーズに配慮した機能",
        "All_Educators_Body_Title4": "教師用資料",
        "All_Educators_Body_Title4_Description1": "保護者の方がご家庭でお子さまを指導するために活用できる資料を提供します。",
        "All_Educators_Body_Title4_Subtitle1": "新年度を迎えた保護者の面談プレゼンテーション資料",
        "All_Educators_Body_Title4_Subtitle2": "家庭通信",
        "All_Educators_Body_Title4_Subtitle3": "保護者用ガイド",
        "All_Educators_Body_Title4_Subtitle4": "トドさんすう活用ガイド",
        "All_Educators_Body_Title4_Button1": "ダウンロード（PDF）",
        "All_Educators_Body_Title4_Button2": "カラーバージョン（DOCX）",
        "All_Educators_Body_Title4_Button3": "白黒バージョン（DOCX）",
        "All_Educators_Body_Title1_Quote1_source1": "Lisa・小学1年生の教師・アメリカ ニュージャージー州",
        "All_Educators_Body_Title1_Quote2_source1": "匿名・2015年教師対象認識調査",
        "All_Educators_Body_Title1_Quote3_source1": "特別学級教師",
        "All_Educators_Body_Title5": "",
        "All_Educators_Body_Title1_Subtitle1": "使用している教師の感想"
    }
}


// WEBPACK FOOTER //
// ./src/text/educator/laptop.js